import { ArenaProfile } from 'shared/contexts/ArenaProfileContext';
import { USE_MOCK_API } from 'shared/services/api/config';
import { createDemoSource, DemoScenario } from 'modules/arena/reports/source/demoSource';
import { createNotConnectedSource } from 'modules/arena/reports/source/notConnectedSource';
import { ReportsSource } from 'modules/arena/reports/source/types';

/**
 * Escolhe a fonte dos relatórios. Dados de demonstração SÓ no modo explícito de protótipo
 * (REACT_APP_USE_MOCK_API ≠ 'false'); fora dele a tela mostra "fonte não conectada" — nunca
 * números fictícios. A integração real deve implementar ReportsSource e entrar aqui.
 */
export function createReportsSource(profile: ArenaProfile, isCustom: boolean, scenario: DemoScenario): ReportsSource {
  if (USE_MOCK_API) return createDemoSource(profile, isCustom, scenario);
  return createNotConnectedSource(profile.arenaName);
}

export const IS_DEMO_REPORTS = USE_MOCK_API;
